import { paginated } from '../helpers'

const initialState = {
  page: {
    limit: 30,
    offset: 0
  }
}

const invoiceModule = {
  namespaced: true,
  state: { ...initialState },
  mutations: {
    ...paginated.mutations
  }
}

export default invoiceModule
export { initialState }
